export default "/static/featured/tcm-banner.jpg"